// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalog.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { GrantReason } from "../../app/v1/app_entitlement_user_binding_reasons";
import { User } from "../../user/v1/user";
import { CatalogEntry } from "../../app/v1/app_entitlement";
import { AppResourceExpandMask } from "../../app/v1/app_resource";
import { AppResourceRef } from "../../app/v1/app_resource";
import { Facets } from "../../search/v1/facet";
import { AppResourceView } from "../../app/v1/app_resource";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { AppEntitlement } from "../../app/v1/app_entitlement";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Task } from "../../task/v1/task";
import { AppEntitlementUserView } from "../../app/v1/app_entitlement";
import { AppResourceType } from "../../app/v1/app_resource";
import { AppResource } from "../../app/v1/app_resource";
import { App } from "../../app/v1/app";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlementUserBinding } from "../../app/v1/app_entitlement_user_binding";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { AppEntitlementExpandMask } from "../../app/v1/app_entitlement";
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceRequest
 */
export interface AccessRequestUrlManagerServiceRequest {
    /**
     * @generated from protobuf field: string token = 1;
     */
    token: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceResponse
 */
export interface AccessRequestUrlManagerServiceResponse {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AccessRequestQueryObject data = 1;
     */
    data?: AccessRequestQueryObject;
    /**
     * @generated from protobuf field: int64 numeric_ticket_id = 2;
     */
    numericTicketId: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateRequest
 */
export interface AccessRequestUrlManagerServiceGenerateRequest {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AccessRequestQueryObject data = 1;
     */
    data?: AccessRequestQueryObject;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateResponse
 */
export interface AccessRequestUrlManagerServiceGenerateResponse {
    /**
     * @generated from protobuf field: string token = 1;
     */
    token: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestQueryObject
 */
export interface AccessRequestQueryObject {
    /**
     * @generated from protobuf field: string userId = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: string appId = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlementId = 3;
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: int64 grantDuration = 4;
     */
    grantDuration: number;
    /**
     * @generated from protobuf field: string reason = 5;
     */
    reason: string;
    /**
     * @generated from protobuf field: string externalUrl = 6;
     */
    externalUrl: string;
    /**
     * @generated from protobuf field: string integrationId = 7;
     */
    integrationId: string;
    /**
     * @generated from protobuf field: bool submit = 8;
     */
    submit: boolean;
    /**
     * @generated from protobuf field: string requestId = 10;
     */
    requestId: string;
    /**
     * @generated from protobuf field: repeated string entitlementIds = 11;
     */
    entitlementIds: string[];
    /**
     * @generated from protobuf field: bool isEmergencyAccess = 12;
     */
    isEmergencyAccess: boolean;
    /**
     * @generated from protobuf field: string appUserId = 13;
     */
    appUserId: string;
}
/**
 * The RequestCatalogSearchServiceSearchEntitlementsRequest searches entitlements, but only ones that are available to you through the open catalogs.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest
 */
export interface RequestCatalogSearchServiceSearchEntitlementsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Fuzzy search the display name of resource types.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * Search for entitlements with this alias (exact match).
     *
     * @generated from protobuf field: string entitlement_alias = 4;
     */
    entitlementAlias: string;
    /**
     * The expand mask descibes what paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Search entitlements with this granted status for your signed in user.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter granted_status = 6;
     */
    grantedStatus: RequestCatalogSearchServiceSearchEntitlementsRequest_GrantedStatusFilter;
    /**
     * Search entitlements that belong to this app name (exact match).
     *
     * @generated from protobuf field: string app_display_name = 7;
     */
    appDisplayName: string;
    /**
     * Include deleted entitlements
     *
     * @generated from protobuf field: bool include_deleted = 8;
     */
    includeDeleted: boolean;
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter
 */
export enum RequestCatalogSearchServiceSearchEntitlementsRequest_GrantedStatusFilter {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Show entitlements that are both granted and not granted. Leaving this field blank will default to "ALL".
     *
     * @generated from protobuf enum value: ALL = 1;
     */
    ALL = 1,
    /**
     * Show entitlements that are granted.
     *
     * @generated from protobuf enum value: GRANTED = 2;
     */
    GRANTED = 2,
    /**
     * Show entitlements that are not granted.
     *
     * @generated from protobuf enum value: NOT_GRANTED = 3;
     */
    NOT_GRANTED = 3
}
/**
 * The AppEntitlementWithUserBindings message represents an app entitlement and its associated user bindings.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementWithUserBindings
 */
export interface AppEntitlementWithUserBindings {
    /**
     * The app entitlement that the user bindings are associated with.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * An array of AppEntitlementUserBinding objects which represent the relationships that give app users access to the specific app entitlement.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBinding app_entitlement_user_bindings = 2;
     */
    appEntitlementUserBindings: AppEntitlementUserBinding[];
}
/**
 * The RequestCatalogSearchServiceSearchEntitlementsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsResponse
 */
export interface RequestCatalogSearchServiceSearchEntitlementsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppEntitlementWithUserBindings list = 1;
     */
    list: AppEntitlementWithUserBindings[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest
 */
export interface RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string catalog_ids = 6;
     */
    catalogIds: string[];
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 7;
     */
    grantEnrollmentStatus: GrantEnrollmentStatus;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus
 */
export interface BundleAppsWithGrantEnrollmentStatus {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 2;
     */
    grantEnrollmentStatus: GrantEnrollmentStatus;
    /**
     * @generated from protobuf field: int32 app_entitlements_total = 3;
     */
    appEntitlementsTotal: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleResponse
 */
export interface RequestCatalogSearchServiceListBrowsableAppsInBundleResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus list = 1;
     */
    list: BundleAppsWithGrantEnrollmentStatus[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleRequest
 */
export interface RequestCatalogSearchServiceListBrowsableAppsInBundleRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string target_user_id = 3;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string catalog_id = 4;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs = 7;
     */
    refs: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest
 */
export interface RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse
 */
export interface RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string target_user_id = 4;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: repeated string catalog_ids = 5;
     */
    catalogIds: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 6;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs = 7;
     */
    refs: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: bool exclude_credential_type = 5;
     */
    excludeCredentialType: boolean;
    /**
     * @generated from protobuf field: int32 page_size = 6;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 7;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppResourceWithType list = 1;
     */
    list: AppResourceWithType[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: int64 app_resource_count = 3;
     */
    appResourceCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountRequest
 */
export interface RequestCatalogSearchServiceSearchAppResourcesCountRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: bool exclude_credential_type = 5;
     */
    excludeCredentialType: boolean;
    /**
     * @generated from protobuf field: int32 page_size = 6;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 7;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppResourceCountsByResourceType
 */
export interface AppResourceCountsByResourceType {
    /**
     * @generated from protobuf field: string app_resource_type_id = 1;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: int64 resource_count = 2;
     */
    resourceCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountResponse
 */
export interface RequestCatalogSearchServiceSearchAppResourcesCountResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppResourceCountsByResourceType list = 2;
     */
    list: AppResourceCountsByResourceType[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppResourceWithType
 */
export interface AppResourceWithType {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource resource = 1;
     */
    resource?: AppResource;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType resource_type = 2;
     */
    resourceType?: AppResourceType;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppWithGrantStatus
 */
export interface AppWithGrantStatus {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView binding = 2;
     */
    binding?: AppEntitlementUserView;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BrowsableAppWithResourceCount
 */
export interface BrowsableAppWithResourceCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView binding = 2;
     */
    binding?: AppEntitlementUserView;
    /**
     * @generated from protobuf field: int32 resource_count = 3;
     */
    resourceCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse
 */
export interface RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppWithGrantStatus list = 1;
     */
    list: AppWithGrantStatus[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BrowsableAppWithResourceCount list = 1;
     */
    list: BrowsableAppWithResourceCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAppsWithCount
 */
export interface BundleAppsWithCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: int32 app_entitlements_granted = 2;
     */
    appEntitlementsGranted: number;
    /**
     * @generated from protobuf field: int32 app_entitlements_total = 3;
     */
    appEntitlementsTotal: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BundleAppsWithCount list = 1;
     */
    list: BundleAppsWithCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesRequest
 */
export interface RequestCatalogSearchServiceSearchTasksForResourcesRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_ids = 5;
     */
    resourceIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 6;
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 7;
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated string catalog_ids = 8;
     */
    catalogIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef
 */
export interface RequestCatalogSearchServiceSearchEntitlementsPerAppRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: int32 page_size = 5;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 6;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_ids = 7;
     */
    resourceIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 8;
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 9;
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef refs = 10;
     */
    refs: RequestCatalogSearchServiceSearchEntitlementsPerAppRef[];
    /**
     * @generated from protobuf field: repeated string catalog_ids = 11;
     */
    catalogIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list = 1;
     */
    list: RequestCatalogUserEntitlementPerApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserRequest
 */
export interface RequestCatalogSearchServiceSearchEntitlementsForUserRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 5;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 6;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 7;
     */
    grantEnrollmentStatus: GrantEnrollmentStatus;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserResponse
 */
export interface RequestCatalogSearchServiceSearchEntitlementsForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list = 1;
     */
    list: RequestCatalogUserEntitlementPerApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesResponse
 */
export interface RequestCatalogSearchServiceSearchTasksForResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogResourceHasTask list = 1;
     */
    list: RequestCatalogResourceHasTask[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp
 */
export interface RequestCatalogUserEntitlementPerApp {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2;
     */
    appEntitlementUserBinding?: AppEntitlementUserView;
    /**
     * @generated from protobuf field: c1.api.task.v1.Task task = 3;
     */
    task?: Task;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogResourceHasTask
 */
export interface RequestCatalogResourceHasTask {
    /**
     * @generated from protobuf field: string resource_id = 1;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: bool has_task = 2;
     */
    hasTask: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp list = 1;
     */
    list: RequestCatalogUserAccessEntitlementPerApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp
 */
export interface RequestCatalogUserAccessEntitlementPerApp {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2;
     */
    appEntitlementUserBinding?: AppEntitlementUserView;
    /**
     * @generated from protobuf field: c1.api.task.v1.Task task = 3;
     */
    task?: Task;
    /**
     * @generated from protobuf field: bool isRequestable = 4;
     */
    isRequestable: boolean;
}
/**
 * The RequestCatalog is used for managing which entitlements are requestable, and who can request them.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalog
 */
export interface RequestCatalog {
    /**
     * The id of the request catalog.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The display name of the request catalog.
     *
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * The description of the request catalog.
     *
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * The datetime, in RFC3339 format, of when the RequestCatalog was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the RequestCatalog was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the RequestCatalog was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 11;
     */
    deletedAt?: Timestamp;
    /**
     * The id of the user this request catalog was created by.
     *
     * @generated from protobuf field: string created_by_user_id = 6;
     */
    createdByUserId: string;
    /**
     * An array of app entitlements that, if the user has, can view the contents of this catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlement access_entitlements = 8;
     */
    accessEntitlements: AppEntitlement[];
    /**
     * If this is true, the access entitlement requirement is ignored.
     *
     * @generated from protobuf field: bool visible_to_everyone = 9;
     */
    visibleToEveryone: boolean;
    /**
     * Whether or not this catalog is published.
     *
     * @generated from protobuf field: bool published = 10;
     */
    published: boolean;
    /**
     * Whether all the entitlements in the catalog can be requests at once. Your tenant must have the bundles feature to use this.
     *
     * @generated from protobuf field: bool request_bundle = 12;
     */
    requestBundle: boolean;
    /**
     * Defines how to handle the request policies of the entitlements in the catalog during enrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior = 13;
     */
    enrollmentBehavior: RequestCatalogEnrollmentBehavior;
    /**
     * Defines how to handle the revocation of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior = 14;
     */
    unenrollmentBehavior: RequestCatalogUnenrollmentBehavior;
    /**
     * Defines how to handle the revoke policies of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior = 15;
     */
    unenrollmentEntitlementBehavior: RequestCatalogUnenrollmentEntitlementBehavior;
}
/**
 * The request catalog view contains the serialized request catalog and paths to objects referenced by the request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogView
 */
export interface RequestCatalogView {
    /**
     * The serialized request catalog.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalog request_catalog = 1;
     */
    requestCatalog?: RequestCatalog;
    /**
     * JSONPATH expression indicating the location of the User object, that created the request catalog, in the array.
     *
     * @generated from protobuf field: string created_by_user_path = 2;
     */
    createdByUserPath: string;
    /**
     * JSONPATH expression indicating the location of the access entitlement objects, that the request catalog allows users to request, in the array.
     *
     * @generated from protobuf field: string access_entitlements_path = 4;
     */
    accessEntitlementsPath: string;
    /**
     * Total number of the members of the catalog
     *
     * @generated from protobuf field: int64 member_count = 5;
     */
    memberCount: number;
}
/**
 * The RequestCatalogExpandMask includes the paths in the catalog view to expand in the return value of this call.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogExpandMask
 */
export interface RequestCatalogExpandMask {
    /**
     * An array of paths to be expanded in the response. May be any combination of "*", "created_by_user_id", "app_ids", and "access_entitlements".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchResourceTypesPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6;
     */
    resourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount
 */
export interface ResourceTypeWithEntitlementCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType resource = 1;
     */
    resource?: AppResourceType;
    /**
     * @generated from protobuf field: int64 count = 2;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchResourceTypesPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount list = 1;
     */
    list: ResourceTypeWithEntitlementCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CatalogRef
 */
export interface CatalogRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsRequest
 */
export interface SearchRequestCatalogsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 4;
     */
    appEntitlements: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.CatalogRef refs = 5;
     */
    refs: CatalogRef[];
    /**
     * @generated from protobuf field: bool include_app_catalogs = 6;
     */
    includeAppCatalogs: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsResponse
 */
export interface SearchRequestCatalogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalog list = 1;
     */
    list: RequestCatalog[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsRequest
 */
export interface SearchRequestCatalogsWithEnrollmentCountsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 4;
     */
    appEntitlements: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.CatalogRef refs = 5;
     */
    refs: CatalogRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsResponse
 */
export interface SearchRequestCatalogsWithEnrollmentCountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView list = 1;
     */
    list: RequestCatalogWithEnrollmentCountView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView
 */
export interface RequestCatalogWithEnrollmentCountView {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalog request_catalog = 1;
     */
    requestCatalog?: RequestCatalog;
    /**
     * @generated from protobuf field: int64 count = 2;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogsRef
 */
export interface AppEntitlementWithRequestCatalogsRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs
 */
export interface AppEntitlementWithRequestCatalogs {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 1;
     */
    entitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource app_resource = 2;
     */
    appResource?: AppResource;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType app_resource_type = 3;
     */
    appResourceType?: AppResourceType;
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalog catalogs = 4;
     */
    catalogs: RequestCatalog[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest
 */
export interface SearchAppEntitlementsWithRequestCatalogsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 5;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 6;
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: string alias = 7;
     */
    alias: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 8;
     */
    refs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsResponse
 */
export interface SearchAppEntitlementsWithRequestCatalogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs list = 1;
     */
    list: AppEntitlementWithRequestCatalogs[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsRequest
 */
export interface GetAppEntitlementWithRequestCatalogsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsResponse
 */
export interface GetAppEntitlementWithRequestCatalogsResponse {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs entitlement = 1;
     */
    entitlement?: AppEntitlementWithRequestCatalogs;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchResourcesPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_ids = 6;
     */
    resourceIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResourceWithEntitlementCount
 */
export interface ResourceWithEntitlementCount {
    /**
     * @generated from protobuf field: int64 count = 2;
     */
    count: number;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceView item = 3;
     */
    item?: AppResourceView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 4;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchResourcesPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.ResourceWithEntitlementCount list = 1;
     */
    list: ResourceWithEntitlementCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsResponse
 */
export interface AppEntitlementsInCatalogTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest
 */
export interface AppEntitlementsInCatalogTermsRequest {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest search = 1;
     */
    search?: SearchAppEntitlementsInCatalogRequest;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType term = 2;
     */
    term: AppEntitlementsInCatalogTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType
 */
export enum AppEntitlementsInCatalogTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APPLICATION_IDS = 1;
     */
    APPLICATION_IDS = 1,
    /**
     * @generated from protobuf enum value: RESOURCE_TYPE_IDS = 2;
     */
    RESOURCE_TYPE_IDS = 2
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersRequest
 */
export interface SearchRemovedUsersRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogRequest
 */
export interface SearchAppResourcesInCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef refs = 5;
     */
    refs: AppResourceRef[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceExpandMask expand_mask = 6;
     */
    expandMask?: AppResourceExpandMask;
    /**
     * @generated from protobuf field: repeated string app_ids = 7;
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipRequest
 */
export interface CountUsersLosingMembershipRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipResponse
 */
export interface CountUsersLosingMembershipResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest
 */
export interface SearchAppEntitlementsInCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef refs = 7;
     */
    refs: RequestCatalogAppEntitlementBindingRef[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 8;
     */
    resourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogResponse
 */
export interface SearchAppEntitlementsInCatalogResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.CatalogEntry list = 4;
     */
    list: CatalogEntry[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersResponse
 */
export interface SearchRemovedUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogResponse
 */
export interface SearchAppResourcesInCatalogResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceView list = 1;
     */
    list: AppResourceView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesRequest
 */
export interface SearchRequestCatalogBundlesRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_enrollment_disabled = 5;
     */
    includeEnrollmentDisabled: boolean;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus enrollment_status = 6;
     */
    enrollmentStatus: GrantEnrollmentStatus;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesResponse
 */
export interface SearchRequestCatalogBundlesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalog list = 1;
     */
    list: RequestCatalog[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef
 */
export interface RequestCatalogAppEntitlementBindingRef {
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipRequest
 */
export interface AccessProfileMembershipRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_profile_id = 3;
     */
    accessProfileId: string;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipResponse
 */
export interface AccessProfileMembershipResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AccessProfileMembership list = 1;
     */
    list: AccessProfileMembership[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessProfileMembership
 */
export interface AccessProfileMembership {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement access_profile = 1;
     */
    accessProfile?: AppEntitlement;
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2;
     */
    user?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp added_at = 3;
     */
    addedAt?: Timestamp;
    /**
     * How the user was added (manual, automation, etc.)
     *
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason added_via = 4;
     */
    addedVia: GrantReason[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string target_user_id = 2;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4;
     */
    resourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType
 */
export interface AppResourceWithEntitlementCountType {
    /**
     * @generated from protobuf field: string app_resource_type_id = 1;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: int64 app_entitlement_count = 2;
     */
    appEntitlementCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType list = 1;
     */
    list: AppResourceWithEntitlementCountType[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppRequest
 */
export interface RequestCatalogSearchServiceEntitlementCountByAppRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string query = 2;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 3;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 4;
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest
 */
export interface RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 4;
     */
    refs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse
 */
export interface RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppWithEntitlementCountType
 */
export interface AppWithEntitlementCountType {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int64 entitlement_count = 2;
     */
    entitlementCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppResponse
 */
export interface RequestCatalogSearchServiceEntitlementCountByAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppWithEntitlementCountType list = 1;
     */
    list: AppWithEntitlementCountType[];
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.GrantEnrollmentStatus
 */
export enum GrantEnrollmentStatus {
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_FULLY_GRANTED = 1;
     */
    FULLY_GRANTED = 1,
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_NOT_GRANTED = 2;
     */
    NOT_GRANTED = 2,
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_PARTIALLY_GRANTED = 3;
     */
    PARTIALLY_GRANTED = 3
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogType
 */
export enum RequestCatalogType {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_TYPE_CATALOG = 1;
     */
    CATALOG = 1,
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_TYPE_PROFILE = 2;
     */
    PROFILE = 2
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior
 */
export enum RequestCatalogEnrollmentBehavior {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The request policies on the catalog's entitlements are ignored, and the grants will be auto-approved.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_BYPASS_ENTITLEMENT_REQUEST_POLICY = 1;
     */
    BYPASS_ENTITLEMENT_REQUEST_POLICY = 1,
    /**
     * The request policies on the catalog's entitlements are honored.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_ENFORCE_ENTITLEMENT_REQUEST_POLICY = 2;
     */
    ENFORCE_ENTITLEMENT_REQUEST_POLICY = 2
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior
 */
export enum RequestCatalogUnenrollmentBehavior {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Do not create tickets to revoke entitlements when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_LEAVE_ACCESS_AS_IS = 1;
     */
    LEAVE_ACCESS_AS_IS = 1,
    /**
     * Revoke all entitlements within the catalog when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_REVOKE_ALL = 2;
     */
    REVOKE_ALL = 2,
    /**
     * Revoke all entitlements within the catalog that were granted without a justification (based on grant reasons) when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_REVOKE_UNJUSTIFIED = 3;
     */
    REVOKE_UNJUSTIFIED = 3
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior
 */
export enum RequestCatalogUnenrollmentEntitlementBehavior {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The revoke policies on the catalog's entitlements are ignored, and the revocations will be auto-approved.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_BYPASS = 1;
     */
    BYPASS = 1,
    /**
     * The revoke policies on the catalog's entitlements are honored.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_ENFORCE = 2;
     */
    ENFORCE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceRequest$Type extends MessageType<AccessRequestUrlManagerServiceRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceRequest
 */
export const AccessRequestUrlManagerServiceRequest = new AccessRequestUrlManagerServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceResponse$Type extends MessageType<AccessRequestUrlManagerServiceResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceResponse", [
            { no: 1, name: "data", kind: "message", T: () => AccessRequestQueryObject },
            { no: 2, name: "numeric_ticket_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceResponse
 */
export const AccessRequestUrlManagerServiceResponse = new AccessRequestUrlManagerServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceGenerateRequest$Type extends MessageType<AccessRequestUrlManagerServiceGenerateRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateRequest", [
            { no: 1, name: "data", kind: "message", T: () => AccessRequestQueryObject }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateRequest
 */
export const AccessRequestUrlManagerServiceGenerateRequest = new AccessRequestUrlManagerServiceGenerateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceGenerateResponse$Type extends MessageType<AccessRequestUrlManagerServiceGenerateResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateResponse", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateResponse
 */
export const AccessRequestUrlManagerServiceGenerateResponse = new AccessRequestUrlManagerServiceGenerateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestQueryObject$Type extends MessageType<AccessRequestQueryObject> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestQueryObject", [
            { no: 1, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "appId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "entitlementId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "grantDuration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "externalUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "integrationId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "submit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "entitlementIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "isEmergencyAccess", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "appUserId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestQueryObject
 */
export const AccessRequestQueryObject = new AccessRequestQueryObject$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsRequest$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "entitlement_alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 6, name: "granted_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter", RequestCatalogSearchServiceSearchEntitlementsRequest_GrantedStatusFilter], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 7, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 8, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest
 */
export const RequestCatalogSearchServiceSearchEntitlementsRequest = new RequestCatalogSearchServiceSearchEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithUserBindings$Type extends MessageType<AppEntitlementWithUserBindings> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementWithUserBindings", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementWithUserBindings
 */
export const AppEntitlementWithUserBindings = new AppEntitlementWithUserBindings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsResponse$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBindings },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsResponse
 */
export const RequestCatalogSearchServiceSearchEntitlementsResponse = new RequestCatalogSearchServiceSearchEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest$Type extends MessageType<RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest
 */
export const RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest = new RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "grant_enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsRequest = new RequestCatalogSearchServiceSearchBrowsableAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef = new RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAppsWithGrantEnrollmentStatus$Type extends MessageType<BundleAppsWithGrantEnrollmentStatus> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "grant_enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] },
            { no: 3, name: "app_entitlements_total", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus
 */
export const BundleAppsWithGrantEnrollmentStatus = new BundleAppsWithGrantEnrollmentStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceListBrowsableAppsInBundleResponse$Type extends MessageType<RequestCatalogSearchServiceListBrowsableAppsInBundleResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BundleAppsWithGrantEnrollmentStatus },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleResponse
 */
export const RequestCatalogSearchServiceListBrowsableAppsInBundleResponse = new RequestCatalogSearchServiceListBrowsableAppsInBundleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceListBrowsableAppsInBundleRequest$Type extends MessageType<RequestCatalogSearchServiceListBrowsableAppsInBundleRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleRequest
 */
export const RequestCatalogSearchServiceListBrowsableAppsInBundleRequest = new RequestCatalogSearchServiceListBrowsableAppsInBundleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest
 */
export const RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest = new RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse
 */
export const RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse = new RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest = new RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "exclude_credential_type", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 7, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest = new RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceWithType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse = new RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppResourcesCountRequest$Type extends MessageType<RequestCatalogSearchServiceSearchAppResourcesCountRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "exclude_credential_type", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 7, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountRequest
 */
export const RequestCatalogSearchServiceSearchAppResourcesCountRequest = new RequestCatalogSearchServiceSearchAppResourcesCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceCountsByResourceType$Type extends MessageType<AppResourceCountsByResourceType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppResourceCountsByResourceType", [
            { no: 1, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppResourceCountsByResourceType
 */
export const AppResourceCountsByResourceType = new AppResourceCountsByResourceType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppResourcesCountResponse$Type extends MessageType<RequestCatalogSearchServiceSearchAppResourcesCountResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountResponse", [
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceCountsByResourceType },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountResponse
 */
export const RequestCatalogSearchServiceSearchAppResourcesCountResponse = new RequestCatalogSearchServiceSearchAppResourcesCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceWithType$Type extends MessageType<AppResourceWithType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppResourceWithType", [
            { no: 1, name: "resource", kind: "message", T: () => AppResource },
            { no: 2, name: "resource_type", kind: "message", T: () => AppResourceType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppResourceWithType
 */
export const AppResourceWithType = new AppResourceWithType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithGrantStatus$Type extends MessageType<AppWithGrantStatus> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppWithGrantStatus", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "binding", kind: "message", T: () => AppEntitlementUserView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppWithGrantStatus
 */
export const AppWithGrantStatus = new AppWithGrantStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrowsableAppWithResourceCount$Type extends MessageType<BrowsableAppWithResourceCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.BrowsableAppWithResourceCount", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "binding", kind: "message", T: () => AppEntitlementUserView },
            { no: 3, name: "resource_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BrowsableAppWithResourceCount
 */
export const BrowsableAppWithResourceCount = new BrowsableAppWithResourceCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse$Type extends MessageType<RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithGrantStatus },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse
 */
export const RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse = new RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BrowsableAppWithResourceCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsResponse = new RequestCatalogSearchServiceSearchBrowsableAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAppsWithCount$Type extends MessageType<BundleAppsWithCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAppsWithCount", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "app_entitlements_granted", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "app_entitlements_total", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAppsWithCount
 */
export const BundleAppsWithCount = new BundleAppsWithCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BundleAppsWithCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse = new RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchTasksForResourcesRequest$Type extends MessageType<RequestCatalogSearchServiceSearchTasksForResourcesRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesRequest
 */
export const RequestCatalogSearchServiceSearchTasksForResourcesRequest = new RequestCatalogSearchServiceSearchTasksForResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsPerAppRef$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsPerAppRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef
 */
export const RequestCatalogSearchServiceSearchEntitlementsPerAppRef = new RequestCatalogSearchServiceSearchEntitlementsPerAppRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 5, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 6, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogSearchServiceSearchEntitlementsPerAppRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 11, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRequest
 */
export const RequestCatalogSearchServiceSearchEntitlementsPerAppRequest = new RequestCatalogSearchServiceSearchEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogUserEntitlementPerApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppResponse
 */
export const RequestCatalogSearchServiceSearchEntitlementsPerAppResponse = new RequestCatalogSearchServiceSearchEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest
 */
export const RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest = new RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse
 */
export const RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse = new RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsForUserRequest$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsForUserRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27})?$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 6, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "grant_enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserRequest
 */
export const RequestCatalogSearchServiceSearchEntitlementsForUserRequest = new RequestCatalogSearchServiceSearchEntitlementsForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsForUserResponse$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsForUserResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogUserEntitlementPerApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserResponse
 */
export const RequestCatalogSearchServiceSearchEntitlementsForUserResponse = new RequestCatalogSearchServiceSearchEntitlementsForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchTasksForResourcesResponse$Type extends MessageType<RequestCatalogSearchServiceSearchTasksForResourcesResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogResourceHasTask },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesResponse
 */
export const RequestCatalogSearchServiceSearchTasksForResourcesResponse = new RequestCatalogSearchServiceSearchTasksForResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogUserEntitlementPerApp$Type extends MessageType<RequestCatalogUserEntitlementPerApp> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_binding", kind: "message", T: () => AppEntitlementUserView },
            { no: 3, name: "task", kind: "message", T: () => Task }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp
 */
export const RequestCatalogUserEntitlementPerApp = new RequestCatalogUserEntitlementPerApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogResourceHasTask$Type extends MessageType<RequestCatalogResourceHasTask> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogResourceHasTask", [
            { no: 1, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "has_task", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogResourceHasTask
 */
export const RequestCatalogResourceHasTask = new RequestCatalogResourceHasTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest
 */
export const RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest = new RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogUserAccessEntitlementPerApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse
 */
export const RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse = new RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogUserAccessEntitlementPerApp$Type extends MessageType<RequestCatalogUserAccessEntitlementPerApp> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_binding", kind: "message", T: () => AppEntitlementUserView },
            { no: 3, name: "task", kind: "message", T: () => Task },
            { no: 4, name: "isRequestable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp
 */
export const RequestCatalogUserAccessEntitlementPerApp = new RequestCatalogUserAccessEntitlementPerApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalog$Type extends MessageType<RequestCatalog> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "created_by_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "access_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlement },
            { no: 9, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "published", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "request_bundle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "enrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior", RequestCatalogEnrollmentBehavior, "REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_"] },
            { no: 14, name: "unenrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior", RequestCatalogUnenrollmentBehavior, "REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_"] },
            { no: 15, name: "unenrollment_entitlement_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior", RequestCatalogUnenrollmentEntitlementBehavior, "REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalog
 */
export const RequestCatalog = new RequestCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogView$Type extends MessageType<RequestCatalogView> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogView", [
            { no: 1, name: "request_catalog", kind: "message", T: () => RequestCatalog },
            { no: 2, name: "created_by_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "access_entitlements_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "member_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogView
 */
export const RequestCatalogView = new RequestCatalogView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogExpandMask$Type extends MessageType<RequestCatalogExpandMask> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "created_by_user_id", "app_ids", "access_entitlements"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogExpandMask
 */
export const RequestCatalogExpandMask = new RequestCatalogExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourceTypesPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchResourceTypesPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppRequest
 */
export const RequestCatalogSearchServiceSearchResourceTypesPerAppRequest = new RequestCatalogSearchServiceSearchResourceTypesPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeWithEntitlementCount$Type extends MessageType<ResourceTypeWithEntitlementCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount", [
            { no: 1, name: "resource", kind: "message", T: () => AppResourceType },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount
 */
export const ResourceTypeWithEntitlementCount = new ResourceTypeWithEntitlementCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourceTypesPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchResourceTypesPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceTypeWithEntitlementCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppResponse
 */
export const RequestCatalogSearchServiceSearchResourceTypesPerAppResponse = new RequestCatalogSearchServiceSearchResourceTypesPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CatalogRef$Type extends MessageType<CatalogRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.CatalogRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CatalogRef
 */
export const CatalogRef = new CatalogRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsRequest$Type extends MessageType<SearchRequestCatalogsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CatalogRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "include_app_catalogs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsRequest
 */
export const SearchRequestCatalogsRequest = new SearchRequestCatalogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsResponse$Type extends MessageType<SearchRequestCatalogsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsResponse
 */
export const SearchRequestCatalogsResponse = new SearchRequestCatalogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsWithEnrollmentCountsRequest$Type extends MessageType<SearchRequestCatalogsWithEnrollmentCountsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CatalogRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsRequest
 */
export const SearchRequestCatalogsWithEnrollmentCountsRequest = new SearchRequestCatalogsWithEnrollmentCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsWithEnrollmentCountsResponse$Type extends MessageType<SearchRequestCatalogsWithEnrollmentCountsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogWithEnrollmentCountView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsResponse
 */
export const SearchRequestCatalogsWithEnrollmentCountsResponse = new SearchRequestCatalogsWithEnrollmentCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogWithEnrollmentCountView$Type extends MessageType<RequestCatalogWithEnrollmentCountView> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView", [
            { no: 1, name: "request_catalog", kind: "message", T: () => RequestCatalog },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView
 */
export const RequestCatalogWithEnrollmentCountView = new RequestCatalogWithEnrollmentCountView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithRequestCatalogsRef$Type extends MessageType<AppEntitlementWithRequestCatalogsRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogsRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogsRef
 */
export const AppEntitlementWithRequestCatalogsRef = new AppEntitlementWithRequestCatalogsRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithRequestCatalogs$Type extends MessageType<AppEntitlementWithRequestCatalogs> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_resource", kind: "message", T: () => AppResource },
            { no: 3, name: "app_resource_type", kind: "message", T: () => AppResourceType },
            { no: 4, name: "catalogs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalog }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs
 */
export const AppEntitlementWithRequestCatalogs = new AppEntitlementWithRequestCatalogs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRequestCatalogsRequest$Type extends MessageType<SearchAppEntitlementsWithRequestCatalogsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 6, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 8, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest
 */
export const SearchAppEntitlementsWithRequestCatalogsRequest = new SearchAppEntitlementsWithRequestCatalogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRequestCatalogsResponse$Type extends MessageType<SearchAppEntitlementsWithRequestCatalogsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithRequestCatalogs },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsResponse
 */
export const SearchAppEntitlementsWithRequestCatalogsResponse = new SearchAppEntitlementsWithRequestCatalogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementWithRequestCatalogsRequest$Type extends MessageType<GetAppEntitlementWithRequestCatalogsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsRequest
 */
export const GetAppEntitlementWithRequestCatalogsRequest = new GetAppEntitlementWithRequestCatalogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementWithRequestCatalogsResponse$Type extends MessageType<GetAppEntitlementWithRequestCatalogsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsResponse", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementWithRequestCatalogs }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsResponse
 */
export const GetAppEntitlementWithRequestCatalogsResponse = new GetAppEntitlementWithRequestCatalogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourcesPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchResourcesPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppRequest
 */
export const RequestCatalogSearchServiceSearchResourcesPerAppRequest = new RequestCatalogSearchServiceSearchResourcesPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceWithEntitlementCount$Type extends MessageType<ResourceWithEntitlementCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResourceWithEntitlementCount", [
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "item", kind: "message", T: () => AppResourceView },
            { no: 4, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResourceWithEntitlementCount
 */
export const ResourceWithEntitlementCount = new ResourceWithEntitlementCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourcesPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchResourcesPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceWithEntitlementCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppResponse
 */
export const RequestCatalogSearchServiceSearchResourcesPerAppResponse = new RequestCatalogSearchServiceSearchResourcesPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementsInCatalogTermsResponse$Type extends MessageType<AppEntitlementsInCatalogTermsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsResponse
 */
export const AppEntitlementsInCatalogTermsResponse = new AppEntitlementsInCatalogTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementsInCatalogTermsRequest$Type extends MessageType<AppEntitlementsInCatalogTermsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchAppEntitlementsInCatalogRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType", AppEntitlementsInCatalogTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest
 */
export const AppEntitlementsInCatalogTermsRequest = new AppEntitlementsInCatalogTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRemovedUsersRequest$Type extends MessageType<SearchRemovedUsersRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRemovedUsersRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersRequest
 */
export const SearchRemovedUsersRequest = new SearchRemovedUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesInCatalogRequest$Type extends MessageType<SearchAppResourcesInCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppResourcesInCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppResourceExpandMask },
            { no: 7, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogRequest
 */
export const SearchAppResourcesInCatalogRequest = new SearchAppResourcesInCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountUsersLosingMembershipRequest$Type extends MessageType<CountUsersLosingMembershipRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.CountUsersLosingMembershipRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipRequest
 */
export const CountUsersLosingMembershipRequest = new CountUsersLosingMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountUsersLosingMembershipResponse$Type extends MessageType<CountUsersLosingMembershipResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.CountUsersLosingMembershipResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipResponse
 */
export const CountUsersLosingMembershipResponse = new CountUsersLosingMembershipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsInCatalogRequest$Type extends MessageType<SearchAppEntitlementsInCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogAppEntitlementBindingRef },
            { no: 8, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest
 */
export const SearchAppEntitlementsInCatalogRequest = new SearchAppEntitlementsInCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsInCatalogResponse$Type extends MessageType<SearchAppEntitlementsInCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogResponse", [
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CatalogEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogResponse
 */
export const SearchAppEntitlementsInCatalogResponse = new SearchAppEntitlementsInCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRemovedUsersResponse$Type extends MessageType<SearchRemovedUsersResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRemovedUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersResponse
 */
export const SearchRemovedUsersResponse = new SearchRemovedUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesInCatalogResponse$Type extends MessageType<SearchAppResourcesInCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppResourcesInCatalogResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogResponse
 */
export const SearchAppResourcesInCatalogResponse = new SearchAppResourcesInCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogBundlesRequest$Type extends MessageType<SearchRequestCatalogBundlesRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogBundlesRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "include_enrollment_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesRequest
 */
export const SearchRequestCatalogBundlesRequest = new SearchRequestCatalogBundlesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogBundlesResponse$Type extends MessageType<SearchRequestCatalogBundlesResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogBundlesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesResponse
 */
export const SearchRequestCatalogBundlesResponse = new SearchRequestCatalogBundlesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogAppEntitlementBindingRef$Type extends MessageType<RequestCatalogAppEntitlementBindingRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef", [
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef
 */
export const RequestCatalogAppEntitlementBindingRef = new RequestCatalogAppEntitlementBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfileMembershipRequest$Type extends MessageType<AccessProfileMembershipRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessProfileMembershipRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "access_profile_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipRequest
 */
export const AccessProfileMembershipRequest = new AccessProfileMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfileMembershipResponse$Type extends MessageType<AccessProfileMembershipResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessProfileMembershipResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessProfileMembership },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipResponse
 */
export const AccessProfileMembershipResponse = new AccessProfileMembershipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfileMembership$Type extends MessageType<AccessProfileMembership> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessProfileMembership", [
            { no: 1, name: "access_profile", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "user", kind: "message", T: () => User },
            { no: 3, name: "added_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "added_via", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessProfileMembership
 */
export const AccessProfileMembership = new AccessProfileMembership$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest = new RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceWithEntitlementCountType$Type extends MessageType<AppResourceWithEntitlementCountType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType", [
            { no: 1, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType
 */
export const AppResourceWithEntitlementCountType = new AppResourceWithEntitlementCountType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceWithEntitlementCountType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse = new RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceEntitlementCountByAppRequest$Type extends MessageType<RequestCatalogSearchServiceEntitlementCountByAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppRequest
 */
export const RequestCatalogSearchServiceEntitlementCountByAppRequest = new RequestCatalogSearchServiceEntitlementCountByAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest
 */
export const RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest = new RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse
 */
export const RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse = new RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithEntitlementCountType$Type extends MessageType<AppWithEntitlementCountType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppWithEntitlementCountType", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppWithEntitlementCountType
 */
export const AppWithEntitlementCountType = new AppWithEntitlementCountType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceEntitlementCountByAppResponse$Type extends MessageType<RequestCatalogSearchServiceEntitlementCountByAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithEntitlementCountType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppResponse
 */
export const RequestCatalogSearchServiceEntitlementCountByAppResponse = new RequestCatalogSearchServiceEntitlementCountByAppResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogSearchService
 */
export const RequestCatalogSearchService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogSearchService", [
    { name: "SearchEntitlements", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/request_catalog/entitlements", group: "Request Catalog" }] } }, I: RequestCatalogSearchServiceSearchEntitlementsRequest, O: RequestCatalogSearchServiceSearchEntitlementsResponse },
    { name: "SearchAccessProfileMemberships", options: { "authz.method": { role: "VIEWER" } }, I: AccessProfileMembershipRequest, O: AccessProfileMembershipResponse },
    { name: "SearchAppsWithGrantStatus", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, O: RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse },
    { name: "SearchEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, O: RequestCatalogSearchServiceSearchEntitlementsPerAppResponse },
    { name: "SearchCatalogEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, O: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse },
    { name: "SearchEntitlementsForUser", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchEntitlementsForUserRequest, O: RequestCatalogSearchServiceSearchEntitlementsForUserResponse },
    { name: "SearchTasksForResources", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchTasksForResourcesRequest, O: RequestCatalogSearchServiceSearchTasksForResourcesResponse },
    { name: "SearchResourceTypesPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, O: RequestCatalogSearchServiceSearchResourceTypesPerAppResponse },
    { name: "SearchAccessEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, O: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse },
    { name: "SearchRequestCatalogs", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestCatalogsRequest, O: SearchRequestCatalogsResponse },
    { name: "SearchRequestCatalogsWithEnrollmentCounts", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestCatalogsWithEnrollmentCountsRequest, O: SearchRequestCatalogsWithEnrollmentCountsResponse },
    { name: "SearchAppEntitlementsWithRequestCatalogs", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithRequestCatalogsRequest, O: SearchAppEntitlementsWithRequestCatalogsResponse },
    { name: "GetAppEntitlementWithRequestCatalogs", options: { "authz.method": { role: "VIEWER" } }, I: GetAppEntitlementWithRequestCatalogsRequest, O: GetAppEntitlementWithRequestCatalogsResponse },
    { name: "SearchResourcesPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchResourcesPerAppRequest, O: RequestCatalogSearchServiceSearchResourcesPerAppResponse },
    { name: "SearchBrowsableApps", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppsRequest, O: RequestCatalogSearchServiceSearchBrowsableAppsResponse },
    { name: "SearchBrowsableAppResources", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, O: RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse },
    { name: "SearchAppResourcesCount", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchAppResourcesCountRequest, O: RequestCatalogSearchServiceSearchAppResourcesCountResponse },
    { name: "ParseAccessRequestToken", options: { "authz.method": { role: "VIEWER" } }, I: AccessRequestUrlManagerServiceRequest, O: AccessRequestUrlManagerServiceResponse },
    { name: "GenerateAccessRequestToken", options: { "authz.method": { role: "VIEWER" } }, I: AccessRequestUrlManagerServiceGenerateRequest, O: AccessRequestUrlManagerServiceGenerateResponse },
    { name: "SearchAppEntitlementsInCatalog", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsInCatalogRequest, O: SearchAppEntitlementsInCatalogResponse },
    { name: "SearchRemovedUsers", options: { "authz.method": { role: "VIEWER" } }, I: SearchRemovedUsersRequest, O: SearchRemovedUsersResponse },
    { name: "CountUsersLosingMembership", options: { "authz.method": { role: "VIEWER" } }, I: CountUsersLosingMembershipRequest, O: CountUsersLosingMembershipResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementsInCatalogTermsRequest, O: AppEntitlementsInCatalogTermsResponse },
    { name: "SearchRequestCatalogBundles", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestCatalogBundlesRequest, O: SearchRequestCatalogBundlesResponse },
    { name: "SearchAppResourcesInCatalog", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourcesInCatalogRequest, O: SearchAppResourcesInCatalogResponse },
    { name: "SearchBrowsableAppsInBundle", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, O: RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse },
    { name: "ListBrowsableAppsInBundle", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, O: RequestCatalogSearchServiceListBrowsableAppsInBundleResponse },
    { name: "SearchCatalogEnrollmentsCount", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, O: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse },
    { name: "SearchBrowsableAppEntitlementsCount", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, O: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse },
    { name: "SearchCatalogEntitlementCountByApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceEntitlementCountByAppRequest, O: RequestCatalogSearchServiceEntitlementCountByAppResponse },
    { name: "SearchCatalogAccessEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, O: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse }
]);
